import { render, staticRenderFns } from "./BiologicalWarningCapture.vue?vue&type=template&id=127ad2ea&scoped=true"
import script from "./BiologicalWarningCapture.vue?vue&type=script&lang=js"
export * from "./BiologicalWarningCapture.vue?vue&type=script&lang=js"
import style0 from "./BiologicalWarningCapture.vue?vue&type=style&index=0&id=127ad2ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127ad2ea",
  null
  
)

export default component.exports